export const API_DA = {    
    format: {        
        title: "Filformat",
        p1: "Filen skal være en tekstfil",
        p2: "Første linje skal indeholde ID for runden. Du finder ID’et under information på rundens side eller i listen ovenfor",
        p3: "Filen skal indeholde enkeltrækker. Første tegn er E",
        p4: "Hver linje i filen indeholder en systemrække",        
        p5: "Kampene adskilles med komma" 
    },
    example: {
        title: "Eksempel",
        row1: "123",
        row2: "E,1,2,X,1,2,1,2,X,1,1,1,1,1",
        row3: "E,1,2,X,1,2,1,2,X,1,1,1,1,1"
    },
    info: "Upload en fil med rækker, du har oprettet i et tipsprogram eller manuelt"
}
